import script from "./invoiceApplyInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./invoiceApplyInfo.vue?vue&type=script&setup=true&lang=js"

import "./invoiceApplyInfo.vue?vue&type=style&index=0&id=65332025&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65332025"]])

export default __exports__